<div class="thp-container">
  <app-talent-happy-path-header [headerText]="postingInfo ? postingInfo.jobTitle : 'talent-happy-path.welcome-text'"></app-talent-happy-path-header>
  <div class="thp-container-body">
    <div class="thp-message">
      <h3>{{ titleText }}</h3>
      <p [ngStyle]="{'white-space': isGather? 'pre-line' : ''}">{{ messageText }}</p>
    </div>
    <a mat-flat-button color="primary" class="continue-button single-custom-button thank-you-button" [href]="buttonURL">{{ buttonText }}</a>
  </div>
  <app-talent-happy-path-footer class="thp-footer"></app-talent-happy-path-footer>
</div>
